import React, { useEffect, useMemo, useState } from "react";
import Header from "./Header";
import GuestHeader from "./GuestHeader";
import UserHeader from "./UserHeader";
import AdminHeader from "./AdminHeader";

export default function HeaderApp({
  currentUser,
  currentCompanyUser,
  companyRole,
  unreadInitial,
  onClickLogout,
}) {
  const [unread, setUnread] = useState(unreadInitial);

  const isGuest = !currentUser && !currentCompanyUser;
  const isCompany = !!currentCompanyUser;
  const isAdmin = !!currentUser?.admin_flag;
  const companyUserRole = currentCompanyUser?.role;

  // HeaderからSidebar開閉したいので、イベントで通知
  const onOpenMenu = () => {
    window.dispatchEvent(new CustomEvent("app:toggleSidebar"));
  };

  useEffect(() => {
    const handler = (event) => {
      setUnread(event.detail);
    };
    window.addEventListener("unread:updated", handler);
    return () => window.removeEventListener("unread:updated", handler);
  }, []);

  const homeHref = useMemo(() => {
    // Guest
    if (isGuest) return "/";

    // User（個人）
    if (!isCompany) return "/skill_sheets";

    // CompanyUser
    if (companyRole === "recruit") return "/company/candidates";

    if (companyRole === "management") {
      return companyUserRole === "employee" ? "/skill_sheets" : "/company/members";
    }

    // fallback
    return "/";
  }, [isGuest, isCompany, companyRole, companyUserRole]);

  const rightSlot = useMemo(() => {
    if (isGuest) return <GuestHeader />;
    if (isAdmin) return <AdminHeader unread={unread} onClickLogout={onClickLogout} />;
    return <UserHeader unread={unread} onClickLogout={onClickLogout} isCompany={isCompany} />;
  }, [isGuest, isAdmin, unread, onClickLogout, isCompany]);

  return (
    <Header
      isGuest={isGuest}
      onOpenMenu={onOpenMenu}
      rightSlot={rightSlot}
      homeHref={homeHref}
    />
  );
}
